import DeleteSweepOutlined from '@mui/icons-material/DeleteSweepOutlined';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type BookFormDraftToolbarProps = {
  showPersistedBanner: boolean;
  clearConfirmOpen: boolean;
  onOpenClearConfirm: () => void;
  onCloseClearConfirm: () => void;
  onConfirmClear: () => void;
};

export default function BookFormDraftToolbar({
  showPersistedBanner,
  clearConfirmOpen,
  onOpenClearConfirm,
  onCloseClearConfirm,
  onConfirmClear,
}: BookFormDraftToolbarProps) {
  return (
    <>
      <Dialog
        open={clearConfirmOpen}
        onClose={onCloseClearConfirm}
        aria-labelledby="book-clear-draft-title"
        aria-describedby="book-clear-draft-desc"
      >
        <DialogTitle id="book-clear-draft-title">Ноорог цэвэрлэх</DialogTitle>
        <DialogContent>
          <DialogContentText id="book-clear-draft-desc">
            Түр хадгалсан номыг устгана. Энэ үйлдлийг буцаах боломжгүй.
            Үргэлжлүүлэх үү?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button type="button" onClick={onCloseClearConfirm}>
            Болих
          </Button>
          <Button type="button" color="warning" variant="contained" onClick={onConfirmClear} autoFocus>
            Тийм, цэвэрлэх
          </Button>
        </DialogActions>
      </Dialog>

      {showPersistedBanner ? (
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} spacing={1} useFlexGap>
          <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
            Түр хадгалсан ном веб хөтчид түр хадгалагдсан байна.
          </Typography>
          <Button
            type="button"
            variant="outlined"
            color="warning"
            size="small"
            startIcon={<DeleteSweepOutlined />}
            onClick={onOpenClearConfirm}
          >
            Ном шинээр эхлэх
          </Button>
        </Stack>
      ) : null}
    </>
  );
}
